import {} from 'react';
export const OCREvents = {
    train: 'ocr:event:train',
    updating: 'ocr:event:updating',
    updated: 'ocr:event:updated',
    cancel: 'ocr:event:cancel',
};
